import { Button, Dialog, Fade, Modal, Paper } from '@mui/material';
import './FileUpload.scss';
import { MutableRefObject, useRef } from 'react';
import Dropzone from 'react-dropzone';

export default function FileUpload({
      handleSave,
      handleAdd,
      open,
      onClose,
      files,
      acceptedFiles
}) {   
      const fileInput = useRef() as MutableRefObject<HTMLInputElement>;

      const handleOpenFile = () => {
            if (!fileInput || !fileInput.current) {
              return;
            }
            fileInput.current.click();
      };

      return (
      <Modal open={open} onClose={onClose} closeAfterTransition={true}>
            <Fade in={open} unmountOnExit={true}><Paper>
                  <Dialog open={open} onClose={onClose} className='upload-dialog'>
                        <div className="dialog-content">
                              <i className='icon-close icon-close-modal' onClick={onClose} />
                              <h1>Upload File(s)</h1>
                              <p>Select the documents you want to upload</p>
                              <p className="file-length">{files.length ? `${files.length} File(s) Uploaded` : ''}</p>
                              <Button variant="outlined" className="browse-files" onClick={handleOpenFile}>Browse File(s)</Button>
                        </div> 
                        <Dropzone maxSize={5000000} onDrop={handleAdd} noClick
                        accept={acceptedFiles}>
                              {({getRootProps, getInputProps, isDragActive, isDragReject}) => { 
                              return (
                                    <div className='dropzone-area-container'> 
                                          <div tabIndex={0} {...getRootProps({ className: `dropzone-area ${isDragActive ?  'dropzone-area-active' : ''} ${isDragReject ? 'dropzone-area-invalid' : ''}`})}>
                                                <input {...getInputProps()} autoComplete='off' ref={fileInput} />
                                                <div className="drop-zone-text-container">
                                                      <p className="drop-zone-text">Drag &amp; Drop your files here OR</p>
                                                </div>
                                          </div>
                                    </div>
                              )}}
                        </Dropzone>
                        <div className="action-buttons">
                              <Button className='btn-cancel' onClick={onClose} >
                                    <span>Cancel</span>
                              </Button>
                              <Button disabled={files.length === 0} className='btn-upload' onClick={handleSave}>
                                    <span>Upload File(s)</span>
                              </Button>
                        </div>
                  </Dialog>
            </Paper></Fade>
      </Modal>
)}